import { Component, Input, OnInit } from "@angular/core";
import { json } from "body-parser";
import * as highcharts from "highcharts";

@Component({
  selector: "app-column-chart",
  templateUrl: "./column-chart.component.html",
  styleUrls: ["./column-chart.component.scss"],
})
export class ColumnChartComponent implements OnInit {
  defaultData = {
    categories: [],
    series: [
      {
        type: "column",
        color: "#FFAD8A",
        name: "Target",
        data: [],
        stops: [[0], [20]],
      },
    ],
  };
  @Input("data")
  set in(val) {
    if (val) {
      this.plotChart(val);
    } else {
      this.plotChart(this.defaultData);
    }
  }
  chartOptions = {};
  highcharts = highcharts;
  constructor() {}

  ngOnInit(): void {
    // this.plotChart(this.defaultData)
  }
  plotChart(data) {
    const xAxisType = (() => {
      if (data.categories) return 'category'; 
      if (data.series && data.series.length > 0) {
        const firstSeries = data.series[0];
        if (firstSeries.data && firstSeries.data.length > 0) {
          const firstPoint = firstSeries.data[0];
          if (typeof firstPoint.x === 'number' && firstPoint.x > 1000000000) {
            return 'datetime'; 
          }
        }
      }
      return 'category'; 
    })();
    return (this.chartOptions = {
      chart: {
        type: "column",
        height: 280,  
        scrollablePlotArea: {
          min: 0,
        },
        zoomType: 'x',
        panning: true,
        reflow:true,
        panKey: 'shift',
        spacingTop: 10,
        spacingBottom: 10,
        spacingLeft: 10,
        spacingRight: 50,
        backgroundColor: false,
        resetZoomButton: {
          "position": {
            "x": 10,
            "y": 40
          }
        }
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        time: {
          useUTC: false,
        },
        shared: true,
        xDateFormat: "%d-%m-%y, %H:%M:%S",
        headerFormat:
          //   '<span style="font-size:14px; font-weight:light">{series.name}<br/> </span>' +
          "<span style='font-size:14px;'>{point.key}</span><table>",
        pointFormat:
          '<tr style="font-size:14px;"><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><span>{point.y:.2f} ' +
          data?.unit +
          "</span></td></tr>",
        footerFormat: "</table>",
        useHTML: true,
        backgroundColor: "#eeeeee",
        borderColor: "#eeeeee",
      },
      // yAxis: {
      //   max: data.max || undefined,
      //   gridLineColor: "#F6F8FA",
      //   labels: {
      //     enabled: data.y_label_enabled ? true : false,
      //   },
      //   plotLines: data.plotLines ? data.plotLines : null,
      //   title: {
      //     text: data.y_title,
      //     enabled: true,
      //     style: {
      //       color: "#595959",
      //       fontSize: 10,
      //     },
      //   },
      // },
      yAxis: {
        max: data.max || null,
        min: 0,
        gridLineWidth: 1,
        gridLineColor: "#D3D3D3",
        labels: {
          enabled: data.y_label_enabled ?? true,
          format: "{value}",
        },
        plotLines: data.plotLines || [],
        title: {
          text: data.y_title,
          style: {
            color: "#595959",
            fontSize: "12px",
          },
        },
      },
      plotOptions: {
        column: {
          maxPointWidth: 20,
          dataLabels: {
            enabled: true,
            style:{
              fontSize:10.5,
              fontWieght:'light',
              enabled: true,
              useHTML: true,
              inside: false,
            }
          }
        },
      },
      xAxis: {
        // type: 'datetime',
        // type: xAxisType,
        type: data.xAxisFormat === 'datetime' ? 'datetime' : 'category',
        labels: {
          // format: '{value:%d-%m %H:%M:%S}'
          // format: data.label || null,
          formatter:function(){
            return this.value
          }
        },
        categories: data?.categories? data?.categories : [],
        scrollbar: {
          enabled: false,
        },
        gridLineColor: "#F6F8FA",
        title: {
          text: data.x_title ? data.x_title : "",
          enabled: true,
          style: {
            color: "#595959",
            fontSize: 10,
          },
        },
      },

      series: data.series,
    });
  }
}
